module.exports = __webpack_public_path__ + "static/media/triangle.cafe7878.svg";